var React = require('react');

function LoginIconInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#4d5255"},[React.createElement("path",{"d":"m15.4999 7.86133c-3.0441 0-5.52041 2.47627-5.52041 5.52037 0 3.0442 2.47631 5.5205 5.52041 5.5205 3.0442 0 5.5204-2.4763 5.5204-5.5205 0-3.0441-2.4762-5.52037-5.5204-5.52037z","key":0}),React.createElement("path",{"d":"m15.5 0c-8.54595 0-15.5 6.95405-15.5 15.5 0 8.5459 6.95405 15.5 15.5 15.5 8.5459 0 15.5-6.9541 15.5-15.5-.0047-8.54595-6.9541-15.5-15.5-15.5zm8.1829 26.4012c-1.0054-3.6213-4.3288-6.2279-8.1829-6.2279s-7.18213 2.6066-8.18288 6.2279c-3.30946-2.4902-5.45526-6.4513-5.45526-10.9012 0-7.51727 6.11622-13.63814 13.63814-13.63814 7.5219 0 13.6381 6.11622 13.6381 13.63814 0 4.4499-2.1458 8.411-5.4552 10.9012z","key":1})]));
}

LoginIconInline.defaultProps = {"fill":"none","height":"31","viewBox":"0 0 31 31","width":"31"};

module.exports = LoginIconInline;

LoginIconInline.default = LoginIconInline;
